// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  defId: __t.string(),
  category: __t.string(),
  styleX100: __t.i32(),
  comfortX100: __t.i32(),
  attractionX100: __t.i32(),
  ratingBonusX100: __t.i32(),
  surface: __t.string(),
};
